<template>
  <section class="protocolo-section py-5">
    <h2 class="protocolo-title mb-4">PROTOCOLO PROVINCIAL</h2>
    <p class="protocolo-description">
      El protocolo de autoridades de la provincia de San Juan es un documento que detalla las autoridades del poder ejecutivo, legislativo y judicial, secretarías, subsecretarías y otras direcciones claves del gobierno provincial.
    </p>

    <div class="protocolo-container">
      <iframe
        src="https://docs.google.com/gview?url=https://contenidodirecto.sanjuan.gob.ar/assets/c8b29fda-ab36-4ed1-bf88-c65d454617a2.pdf.pdf&embedded=true"
        class="protocolo-iframe"
        frameborder="0"
      ></iframe>
    </div>

    <div class="protocolo-download">
      <a
        href="https://contenidodirecto.sanjuan.gob.ar/assets/c8b29fda-ab36-4ed1-bf88-c65d454617a2.pdf.pdf"
        download
        target="_blank"
        rel="noopener noreferrer"
        class="download-btn"
      >
        Descargar PDF
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProtocoloComponent",
};
</script>

<style scoped>
.protocolo-section {
  text-align: center;
  background-color: #f8f9fa;
  padding: 3rem 1rem;
}

.protocolo-title {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
}

.protocolo-description {
  max-width: 700px;
  margin: 1.5rem auto;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a4a4a;
  text-align: center;
}

.protocolo-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.protocolo-iframe {
  width: 80%;
  height: 900px;
  border: 2px solid #dddddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


.protocolo-download {
  margin-top: 2rem;
}

.download-btn {
  display: inline-block;
  background-color: #ff8200;
  color: white;
  text-decoration: none;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.download-btn:hover {
  background-color: #cc6900;
}

@media (max-width: 768px) {
  .protocolo-iframe {
    width: 95%;
    height: 400px;
  }

  .protocolo-description {
    font-size: 1rem;
    padding: 1rem;
  }
}
</style>